<p-card *ngIf="feed.isPlaceholder" >
  <ng-template pTemplate="header">
    <div class="relative">
      <p-skeleton width="100%" height="300px"></p-skeleton>
      <div class="col-12 m-0 flex gap-2 justify-content-start align-items-center" style="position: absolute; bottom: 0">
        <p-skeleton width="8rem" height="2rem" borderRadius="16px"></p-skeleton>
      </div>
    </div>
  </ng-template>
  <div class="grid">
    <div class="col-12 m-0">
      <p-skeleton width="15rem" height="1.2rem"></p-skeleton>
    </div>
    <div class="col-12 m-0 flex gap-5 justify-content-start">
      <p-skeleton width="8rem" height="0.8rem"/>
      <p-skeleton width="10rem" height="0.8rem"/>
    </div>
    <div class="col-12 flex flex-column gap-1">
      <p-skeleton width="100%" height="1rem"/>
      <p-skeleton width="95%" height="1rem"/>
      <p-skeleton width="98%" height="1rem"/>
      <p-skeleton width="12rem" height="1rem"/>
    </div>
    <div class="col-12 grid flex align-items-center">
      <div class="col flex justify-content-start w-100 gap-2">
        <p-skeleton width="3rem" height="2rem" borderRadius="16px"></p-skeleton>
        <p-skeleton width="5rem" height="2rem" borderRadius="16px"></p-skeleton>
        <p-skeleton width="4rem" height="2rem" borderRadius="16px"></p-skeleton>
      </div>
      <div class="col-fixed">
        <button *ngIf="mode !== 'show'" type="button" pButton class="p-button-text" icon="pi pi-arrow-right" [label]="'common.read_more' | translate" [disabled]="true"></button>
        <button *ngIf="mode === 'show'" type="button" pButton class="p-button-text" icon="pi pi-arrow-left" [label]="'common.return_to_list' | translate" [disabled]="true"></button>
      </div>
      <div class="col-fixed">
        <app-end-cap
          icon="pi pi-qrcode"
          [pointerClass]="{
                  'p-button-text p-button-plain m-0': true,
                  'p-button-icon-only': windowWidth < 920
                  }"
          [label]="windowWidth > 920 ? ('common.share'|translate) : null"
          [ariaLabel]="'common.share' | translate"
          [tooltip]="windowWidth > 920 ? null : ('common.share' | translate)"
        >
        </app-end-cap>      </div>
    </div>
  </div>
</p-card>
<p-card *ngIf="!feed.isPlaceholder">
  <ng-template pTemplate="header">
    <div class="relative" [appAspectRatio]="9/16">
      <div *ngIf="mediaDeferred; else feedCover" class="feed-cover"></div>
      <ng-template #feedCover>
        <img alt="Card" class="feed-cover" [ngSrc]="cover|mediaObject: {defaultImageType: 'background', formatType: 'thumb_md'}" [fill]="true" [priority]="lcpPriority" />
      </ng-template>
      <div class="col-12 m-0 flex gap-2 justify-content-start align-items-center" style="position: absolute; bottom: 0">
        <p-chip
          *ngFor="let author of feed.authors; let i = index;"
          [label]="author.username" [image]="mediaDeferred ? null : (author.avatar|mediaObject:{defaultImageType: 'avatar'})"
          [removable]="false"
        ></p-chip>
      </div>
    </div>
  </ng-template>
  <div class="grid xl:px-3">
    <div class="col-12 m-0">
      <h4 class="m-0"><a>{{ feed.heading }}</a></h4>
    </div>
    <div class="col-12 m-0 flex gap-5 justify-content-start">
      <small><a>{{'common.publication_date'|translate}}: {{feed.publishedAt|date:'yyyy-MM-dd HH:mm'}}</a></small>
      <small><a>{{'common.visits'|translate}}: {{feed.visits}}</a></small>
    </div>
    <div class="col-12">
      <p *ngIf="mode !== 'show'" [innerHTML]="feed.content|removeHtmlTags|truncateOnWord:220: '...'"></p>
      <p *ngIf="mode === 'show'" [innerHTML]="feed.content" class="text-justify"></p>
    </div>
    <div class="col-12 grid flex align-items-center">
      <div class="col flex justify-content-start w-100">
        <p-chip
          *ngFor="let author of feed.authors; let i = index;"
          [label]="'#news'"
          [removable]="false"
        ></p-chip>
      </div>
      <div class="col-fixed">
        <button *ngIf="mode !== 'show'" type="button" pButton class="p-button-text" icon="pi pi-arrow-right" [label]="'common.read_more' | translate" [routerLink]="['/feed', feed.slug]"></button>
        <button *ngIf="mode === 'show'" type="button" pButton class="p-button-text" icon="pi pi-arrow-left" [label]="'common.return_to_list' | translate" [routerLink]="['/feed']" [fragment]="feed.slug"></button>
      </div>
      <div class="col-fixed">
        <app-end-cap
          icon="pi pi-qrcode"
          [pointerClass]="{
                  'p-button-text p-button-plain m-0': true,
                  'p-button-icon-only': windowWidth < 920
                  }"
          (onClickTrigger)="openQrDialog()"
          [label]="windowWidth > 920 ? ('common.share'|translate) : null"
          [ariaLabel]="'common.share' | translate"
          [tooltip]="windowWidth > 920 ? null : ('common.share' | translate)"
        >
        </app-end-cap>
      </div>
    </div>
  </div>
</p-card>
<app-qr-dialog [(visible)]="qrDialogVisible" [data]="qrDialogData"></app-qr-dialog>
